import { useEffect } from "react";
import { message } from "antd";
import { useDispatch } from "react-redux";
import { Action } from "redux-saga";

import { useBusiness } from "../../../../store/business";
import { getMessageInError } from "../../../../hooks/fetch";
import {
    businessUpdate,
    businessUpdateClear,
    businessUpdateErrorClear,
    BusinessUpdatePayload,
} from "../../../../store/business/update";

export const useBusinessUpdate = () => {
    const dispatch = useDispatch();
    const { update } = useBusiness();

    const updateBusiness = (payload: BusinessUpdatePayload) => {
        dispatch(businessUpdate(payload) as Action)
    }

    useEffect(() => () => {
        dispatch(businessUpdateClear() as Action)
        dispatch(businessUpdateErrorClear() as Action)
    }, [])

    useEffect(() => {
        if (update.error) {
            message
                .error(getMessageInError(update.error))
                .then(() => dispatch(businessUpdateErrorClear() as Action));
        }
    }, [update.error])

    const clearBusinessById = () => {
        dispatch(businessUpdateClear() as Action)
        dispatch(businessUpdateErrorClear() as Action)
    }

    return { updateBusiness, clearBusinessById, response: update.response, error: update.error, loading: update.loading };
}
